import PropTypes from "prop-types";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, FormHelperText, Grid, Stack, Snackbar, Alert, TextField } from "@mui/material";
import * as Yup from "yup";
import { Formik } from "formik";
import { LOGIN_PAGE, API_ERROR_MESSAGE, API_SUCCESS_MESSAGE, VALIDATON_TEXT, PLACEHOLDER, BUTTON } from "../../shared/constants";
import AuthWrapper from "../../components/Authwrapper";

export default function PasswordReset() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(true);

  const [snackData, setSnackData] = useState({
    show: false,
    message: "",
    type: "error",
  });

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmitForm = (values) => {
    navigate("/login");
    // let payload = values

    // AuthApiService.resetPassword(payload)
    //   .then((response) => {
    //     setSnackData({
    //       show: true,
    //       message: response?.message || API_SUCCESS_MESSAGE.PASSWORD_RESET,
    //       type: "success",
    //     });
    //     navigate("/login"); // Redirect to login page after successful reset
    //   })
    //   .catch((errResponse) => {
    //     setSnackData({
    //       show: true,
    //       message: errResponse?.error?.message || API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR,
    //       type: "error",
    //     });
    //     setSubmitting(false); // This will reset isSubmitting in Formik
    //   });
  };

  return (
    <>
      <AuthWrapper>
        <Formik
          initialValues={{
            email: sessionStorage.getItem("email"),
            password: "",
            confirmPassword: "",
          }}
          validationSchema={Yup.object().shape({
            password: Yup.string()
              .min(8, VALIDATON_TEXT.CHARACTER_LIMIT)
              .matches(/[A-Z]/, VALIDATON_TEXT.UPPERCASE)
              .matches(/[a-z]/, VALIDATON_TEXT.LOWERCASE)
              .matches(/\d/, VALIDATON_TEXT.NUMBER)
              .matches(/[@$!%*?&]/, VALIDATON_TEXT.SPECIAL_CHARACTER)
              .required(VALIDATON_TEXT.PASSWORD_REQUIRED),
            confirmPassword: Yup.string()
              .oneOf([Yup.ref("password"), null], VALIDATON_TEXT.PASSWORD_MATCH)
              .required(VALIDATON_TEXT.CONFIRM_PASSWORD),
          })}
          onSubmit={handleSubmitForm} // Using Formik's onSubmit directly
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
          }) => (
            <form noValidate onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                {/* Password Field */}
                <Grid item xs={12}>
                  <Stack spacing={1}>
                    <TextField
                      required
                      id="password-login"
                      type={showPassword ? "text" : "password"}
                      value={values.password}
                      label={LOGIN_PAGE.NEW_PASSWORD}
                      name="password"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder={PLACEHOLDER.PASSWORD}
                      fullWidth
                      error={Boolean(touched.password && errors.password)}
                    />
                  </Stack>
                  {touched.password && errors.password && (
                    <FormHelperText
                      error
                      id="standard-weight-helper-text-password-reset"
                    >
                      {errors.password}
                    </FormHelperText>
                  )}
                </Grid>

                {/* Confirm Password Field */}
                <Grid item xs={12}>
                  <Stack spacing={1}>
                    <TextField
                      required
                      id="confirm-password-reset"
                      type={showPassword ? "text" : "password"}
                      value={values.confirmPassword}
                      label={LOGIN_PAGE.CONFIRM_PASSWORD}
                      name="confirmPassword"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder={PLACEHOLDER.NEW_PASSWORD}
                      fullWidth
                      error={Boolean(
                        touched.confirmPassword && errors.confirmPassword
                      )}
                    />
                  </Stack>
                  {touched.confirmPassword && errors.confirmPassword && (
                    <FormHelperText
                      error
                      id="standard-weight-helper-text-confirm-password-reset"
                    >
                      {errors.confirmPassword}
                    </FormHelperText>
                  )}
                </Grid>

                {/* Submit Button */}
                {errors.submit && (
                  <Grid item xs={12}>
                    <FormHelperText error>{errors.submit}</FormHelperText>
                  </Grid>
                )}

                <Grid item xs={12}>
                  <Button
                    disableElevation
                    disabled={isSubmitting}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    {BUTTON.RESET}
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>

        <Snackbar
          style={{ top: "80px" }}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={snackData.show}
          autoHideDuration={3000}
          onClose={() => setSnackData({ show: false })}
        >
          <Alert
            onClose={() => setSnackData({ show: false })}
            severity={snackData.type}
          >
            {snackData.message}
          </Alert>
        </Snackbar>
      </AuthWrapper>
    </>
  );
}

PasswordReset.propTypes = {
  isDemo: PropTypes.bool,
};
